// extracted by mini-css-extract-plugin
export default {"app-buttons-desktop":"D_Uf2E","app-buttons-desktop__app":"t680yM"};